import { render } from "./TargetLink.vue?vue&type=template&id=60e5b489&scoped=true"
import script from "./TargetLink.vue?vue&type=script&lang=js"
export * from "./TargetLink.vue?vue&type=script&lang=js"

import "./TargetLink.vue?vue&type=style&index=0&id=60e5b489&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e5b489"]])

export default __exports__